import { secondsDiff, trueNow } from '../..';
import { FinalClueGiver } from '../../api/fishbowl/fishbowlStats';

export function getTimeTaken(finalClueGiver: FinalClueGiver, timeOffset: number) {
    if ('timeTaken' in finalClueGiver) return finalClueGiver.timeTaken;
    const turnDurationMs = finalClueGiver.secondsPerTurn * 1000;
    const unusedTurnMs = finalClueGiver.turnEndTime - trueNow(timeOffset);
    return secondsDiff(turnDurationMs, unusedTurnMs);
}
